import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import React from 'react';
import DesktopComments728x90Gak from './gak/DesktopComments728x90';
import DesktopComments728x90Nitro from './nitro/DesktopComments728x90';
const DesktopComments728x90 = ({ safety ='off'  })=>{
    const isDaAds = useFlag('ads_da');
    if (isDaAds) {
        return /*#__PURE__*/ React.createElement(DesktopComments728x90Gak, {
            safety: safety
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopComments728x90Nitro, {
        safety: safety
    });
};
DesktopComments728x90.displayName = 'DesktopComments728x90';
export default DesktopComments728x90;
